<div  role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Notes</h2>
    </div>
    <div class="modal-body">
      <form #noteForm="ngForm">
        <div class="form-group">
          <label for="noteField" class="col-form-label">Notes</label>
          <textarea name ="note" type="text" class="form-control" id="note" required [(ngModel)]="note.note" rows="5"></textarea>
        </div>
        <div class="field-separator"></div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="reminder">Set Reminder</label>
              <select name="reminder" id="reminder" class="form-control" [(ngModel)]="note.reminder">
                <option value="0">Not Required</option>
                <option value="1">Set Reminder</option>
              </select>
            </div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-4">
            <div class="form-group" *ngIf="note.reminder == '1'">
              <label for="reminderDate"> Reminder Date</label>
              <input type="date" name="reminderDate" id="reminderDate" class="form-control" [(ngModel)]="note.reminderDate">
            </div>
          </div>
        </div>
        <div class="field-separator"></div>
        <section class="example-section">
          <mat-slide-toggle name="popup" id="popup" 
          (change)="setValue($event)"
          [checked]="note.popup == 1">
            Show on Popup
          </mat-slide-toggle>
        </section>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="saveNote()" [disabled]="noteForm.invalid">Save Note</button>
      <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
    </div>
  </div>
</div>